'use strict';

var { debounce } = require('underscore');

var IdleScrollMixin = {
  getInitialState: function () {
    return {
      isScrolling: false
    };
  },

  isScrolling: function () {
    return this.state.isScrolling;
  },

  componentDidMount: function () {
    this._debounceSetScrolling = debounce(this._setScrolling, 800);
  },

  handleScroll() {
    this._setScrolling(true);
    this._debounceSetScrolling(false);
  },

  _setScrolling: function (isScrolling) {
    if (!this.isMounted()) {
      return;
    }

    if (this.state.isScrolling === isScrolling) {
      return;
    }

    this.setState({
      isScrolling: isScrolling
    });
  }
};

module.exports = IdleScrollMixin;


/** WEBPACK FOOTER **
 ** ./mixins/IdleScrollMixin.js
 **/